import { ExplicitAny } from '~/@types/generic'

type Entries<T> = { [K in keyof T]: [K, T[K]] }[keyof T]

export function objectEntries<T extends { [key: string]: ExplicitAny }>(
  t: T,
): Entries<T>[] {
  return Object.entries(t ?? {}) as Entries<T>[]
}
